import { useEffect, useState } from "react"
import dataService from "../services/dataService"
import localforage from "localforage"
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, registerables } from "chart.js"
import { Line } from "react-chartjs-2"
import backButton from "../assets/back.png"
ChartJS.register(...registerables);

export default function CoinHistoryItem({ coinId, hideHistory }) {
    const [monthData, setMonthData] = useState([])
    const [weekData, setWeekData] = useState([])
    const [historyData, setHistory] = useState([])
    const [isWeek, setIsWeek] = useState(true)
    const [coinName, setCoinName] = useState("")
    const [coinSymbol, setCoinSymbol] = useState("")
    let weekClass = isWeek ? "weekButton selected" : "weekButton unSelected"
    let monthClass = !isWeek ? "monthButton selected" : "monthButton unSelected"

    useEffect(() => {
        //fetch symbol and name using id
        console.log("coinId: " + coinId)
        localforage.getItem("preferences").then(prefs => {
            for (var item of prefs) {
                if (item.coinId == coinId) {
                    setCoinName(item.coinName)
                    setCoinSymbol(item.coinSymbol)
                    break
                }
            }
            dataService.getMonthRate(coinId).then(resMonth => {
                dataService.getWeekRate(coinId).then(resWeek => {
                    setMonthData(resMonth)
                    setWeekData(resWeek)
                    if (isWeek) {
                        setHistory(resWeek)
                    }
                    else {
                        setHistory(resMonth)
                    }
                })
            })
        })

    }, [])

    function switchPanel(trigger) {
        if (trigger == "week") {
            setHistory(weekData)
            setIsWeek(true)
        }
        else {
            setIsWeek(false)
            setHistory(monthData)
        }
    }


    let dates = historyData.map(item => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        var dateObj = new Date(item.date)
        let dateStr = dateObj.getDate()
        let monthStr = monthNames[dateObj.getMonth()]
        if (parseInt(dateStr) < 10) { dateStr = "0" + dateStr }
        if (parseInt(monthStr) < 10) { monthStr = "0" + monthStr }
        return (monthStr + " " + dateStr)
    })

    let prices = historyData.map(item => {
        return parseFloat(item.priceUsd).toFixed(2)

    })

    return <div className="coinHistory col">
        <div className="coinHistoryHeader row">
            <div className="coinInfo">
                <button className="back" onClick={hideHistory}><img src={backButton}></img></button>
                <div className="coinName"> {coinName} ({coinSymbol})</div>
            </div>
            <div className="header-buttons">
                <button className={weekClass} onClick={() => { switchPanel("week") }}>
                    Week
                </button>
                <button className={monthClass} onClick={() => { switchPanel("month") }}>
                    Month
                </button>
            </div>
        </div>
        <div className="graph col">
            <Line
                datasetIdKey="data"
                options={{

                    animation: true,
                    pointBackgroundColor: "yellowgreen"
                }}
                data={{
                    labels: dates,
                    datasets: [
                        {
                            id: 1,
                            label: 'prices (USD)',
                            data: prices,
                            borderColor: "yellowgreen"
                        }
                    ]
                }} />
        </div>
    </div>
}

// create function to go back to coin list